export default __webpack_public_path__ + "static/media/leekmap2.ad1f6e07.png";